export interface Compartment {
  readonly halfTimeN2: number;
  readonly aN2: number;
  readonly bN2: number;
  readonly halfTimeHe?: number;
  readonly aHe?: number;
  readonly bHe?: number;
}

export const ZHL16C: readonly Compartment[] = [
  { halfTimeN2: 4.0,   aN2: 1.2599, bN2: 0.5050 },
  { halfTimeN2: 8.0,   aN2: 1.0000, bN2: 0.6514 },
  { halfTimeN2: 12.5,  aN2: 0.8618, bN2: 0.7222 },
  { halfTimeN2: 18.5,  aN2: 0.7562, bN2: 0.7825 },
  { halfTimeN2: 27.0,  aN2: 0.6200, bN2: 0.8126 },
  { halfTimeN2: 38.3,  aN2: 0.5043, bN2: 0.8434 },
  { halfTimeN2: 54.3,  aN2: 0.4410, bN2: 0.8693 },
  { halfTimeN2: 77.0,  aN2: 0.4000, bN2: 0.8910 },
  { halfTimeN2: 109.0, aN2: 0.3750, bN2: 0.9092 },
  { halfTimeN2: 146.0, aN2: 0.3500, bN2: 0.9222 },
  { halfTimeN2: 187.0, aN2: 0.3295, bN2: 0.9319 },
  { halfTimeN2: 239.0, aN2: 0.3065, bN2: 0.9403 },
  { halfTimeN2: 305.0, aN2: 0.2835, bN2: 0.9477 },
  { halfTimeN2: 390.0, aN2: 0.2610, bN2: 0.9544 },
  { halfTimeN2: 498.0, aN2: 0.2480, bN2: 0.9602 },
  { halfTimeN2: 635.0, aN2: 0.2327, bN2: 0.9653 },
] as const;

export const N_COMPARTMENTS = ZHL16C.length;

export const LN2 = Math.LN2;

export function kN2(cpt: Compartment): number {
  return LN2 / cpt.halfTimeN2;
}
